import React, { useRef, useState, useEffect } from "react";
import emailjs from '@emailjs/browser';

function DownloadProspectus() {
  const [showPopup, setShowPopup] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [currentUrl, setCurrentUrl] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef();

  useEffect(() => {
    setCurrentUrl(window.location.href);
  }, []);

  const handleDownloadClick = () => {
    setShowPopup(true);
    // Disable background scroll
    document.body.style.overflow = 'hidden';
  };

  const closePopup = () => {
    setShowPopup(false);
    setShowMessage(false);
    setErrorMessage(false);
    // Re-enable background scroll
    document.body.style.overflow = 'unset';
  };

  const triggerDownload = () => {
    // Trigger the download from your API
    const link = document.createElement('a');
    link.href = 'https://app.akiya2.com/download/akiya-services-all';
    link.download = 'akiya-services-all.pdf'; // or whatever the filename should be
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData(formRef.current);
    formData.append("page_url", currentUrl);

    const jsonData = Object.fromEntries(formData);

    // Add current date and time in the specified format
    const now = new Date();
    const formattedDate = now.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
    const formattedTime = now.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

    jsonData.date = formattedDate;
    jsonData.time = formattedTime;

    try {
      await emailjs.sendForm(
        'service_38109pg',
        'template_vt827qb',
        formRef.current,
        { publicKey: 'C1nLWwz9Kq2nJ90Fa' }
      );



      setShowMessage(true);
      
      // Trigger download after successful form submission
      setTimeout(() => {
        triggerDownload();
        setShowMessage(false);
        closePopup();
      }, 2000);

    } catch (error) {
      console.error('FAILED...', error.text);
      setErrorMessage(true);
      setTimeout(() => setErrorMessage(false), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="flex flex-col items-center md:flex-row my-5 md:mx-3">
        <div className="w-full md:mr-5">
          <h2 className="text-center md:text-right text-[24px] font-[800] mb-3 md:mb-0">
            Download the full services price list.
          </h2>
          <p className="text-center md:text-right text-[#949995] text-[24px] font-[300] leading-[36px]">
            ※ Detailed figures are provided in our full AKIYA2.0 services and
            price list. You can download it here.
          </p>
        </div>

        <div className="w-full mt-3 md:mt-0 md:ml-5 flex justify-center">
          <div className="text-center md:text-right">
            <button 
              onClick={handleDownloadClick}
              className="w-[100vw] md:w-auto md:rounded-md bg-[#10c9c0] px-6 py-4 text-white text-lg font-bold hover:bg-[#0ea29a] transition-colors"
            >
              Download Now
            </button>
          </div>
        </div>
      </div>

      {/* Popup Modal */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999] p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto transform transition-all duration-300 scale-100">
            {/* Header */}
            <div className="flex justify-between items-center p-8 border-b border-gray-100">
              <h3 className="text-2xl font-bold text-black">
                Download Services Price List
              </h3>
              <button 
                onClick={closePopup}
                className="text-gray-400 hover:text-black text-3xl font-light transition-colors duration-200"
              >
                ×
              </button>
            </div>

            {/* Form */}
            <div className="p-8">
              <p className="text-gray-600 mb-8 text-center">
                Please fill out this form to download our comprehensive services price list.
              </p>
              
              <form ref={formRef} onSubmit={sendEmail} className="space-y-6">
                <div className="space-y-6">
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Your name"
                      name="name"
                      required
                      className="w-full h-14 px-4 border-2 border-gray-200 rounded-lg text-base outline-none focus:border-teal-500 focus:shadow-lg transition-all duration-200"
                    />
                  </div>

                  <div className="relative">
                    <input
                      type="email"
                      placeholder="Your email"
                      name="email"
                      required
                      className="w-full h-14 px-4 border-2 border-gray-200 rounded-lg text-base outline-none focus:border-teal-500 focus:shadow-lg transition-all duration-200"
                    />
                  </div>

                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Your Country"
                      name="country"
                      required
                      className="w-full h-14 px-4 border-2 border-gray-200 rounded-lg text-base outline-none focus:border-teal-500 focus:shadow-lg transition-all duration-200"
                    />
                  </div>
                </div>

                {/* Agreement Checkbox */}
                <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-teal-500">
                  <label className="flex items-start">
                    <span className="bg-black text-white text-xs px-2 py-1 mr-3 mt-1 rounded">
                      Req*
                    </span>
                    <span className="font-bold text-black">
                      Handling of personal information
                    </span>
                  </label>
                  <div className="flex items-center mt-4">
                    <input 
                      type="checkbox" 
                      id="agreement"
                      name="agreement"
                      className="mr-3 w-5 h-5 text-teal-600 border-2 border-gray-300 rounded focus:ring-teal-500 focus:ring-2" 
                      required 
                    />
                    <span className="text-gray-700">I have read and accepted the following documents:</span>
                  </div>
                  <div className="ml-8 mt-3">
                    <span className="text-gray-600">
                      <a
                        href="/terms"
                        target="_blank"
                        className="text-teal-600 hover:text-teal-800 font-medium underline decoration-2 underline-offset-2 transition-colors duration-200"
                      >
                        Terms of Service
                      </a>
                      {" and "}
                      <a
                        href="/terms"
                        target="_blank"
                        className="text-teal-600 hover:text-teal-800 font-medium underline decoration-2 underline-offset-2 transition-colors duration-200"
                      >
                        Privacy Policy
                      </a>
                    </span>
                  </div>
                </div>

                {/* Hidden input for page URL */}
                <input type="hidden" name="page_url" value={currentUrl} />

                {/* Submit Button */}
                <div className="pt-4">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-teal-600 text-white py-4 px-6 rounded-lg font-bold text-lg hover:bg-teal-700 active:bg-teal-800 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                  >
                    {isSubmitting ? (
                      <span className="flex items-center justify-center">
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Submitting...
                      </span>
                    ) : (
                      'Download Price List'
                    )}
                  </button>
                </div>
              </form>

              {/* Success Message */}
              {showMessage && (
                <div className="mt-6 bg-teal-50 border-l-4 border-teal-500 text-teal-700 py-4 px-6 rounded-lg">
                  <div className="flex items-center">
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
                    </svg>
                    <p className="font-medium">Thank you! Your download will start shortly...</p>
                  </div>
                </div>
              )}

              {/* Error Message */}
              {errorMessage && (
                <div className="mt-6 bg-red-50 border-l-4 border-red-500 text-red-700 py-4 px-6 rounded-lg">
                  <div className="flex items-center">
                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd"/>
                    </svg>
                    <p className="font-medium">Due to a technical issue, your request was not sent. Please contact us directly at "info@akiya2.com"!</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DownloadProspectus;